import request, {requestImage} from '../main';
const service = ""
class UploadApi {
    private url: string = service + "/file";
    public upload(args: any){
        return requestImage({
            url: this.url + '/upload',
            method: 'post',
            data: args
        })
    }

    // 图片旋转
    public rotateImage(args: any){
        return request({
            url: this.url + '/rotate-image',
            method: 'get',
            params: args
        })
    }
}
const uploadApi = new UploadApi();
export {uploadApi}
